/**
 * APA Style compliance statement (document body) and Section guide copy (modal HTML).
 */

export function isThesisDocumentType(documentTypeName) {
	const n = (documentTypeName || '').toLowerCase();
	return /\bthesis\b/.test(n) && !/\bdissertation\b/.test(n);
}

export function getApaComplianceStatementText(documentTypeName) {
	const thesis = isThesisDocumentType(documentTypeName);
	return thesis
		? 'This thesis follows the style guidelines of the Publication Manual of the American Psychological Association (7th ed.).'
		: 'This dissertation follows the style guidelines of the Publication Manual of the American Psychological Association (7th ed.).';
}

/** Inserted as editor body HTML; id used to sync with checkbox */
export function buildApaComplianceParagraphHtml(documentTypeName) {
	const text = getApaComplianceStatementText(documentTypeName);
	return `<p id="wf-apa-compliance-statement" class="wf-apa-compliance-statement" data-writeform-no-toc="1">${text}</p>`;
}

/** Read-only Section guide: APA compliance (for modal / iframe) */
export function getApaComplianceSectionGuideHtml() {
	return `
<div class="wf-section-guide">
	<p><strong>Purpose</strong></p>
	<p>Include a standard APA 7 compliance line where your program requires it—typically in front matter.</p>
	<p><strong>What to include</strong></p>
	<p>One sentence referencing APA 7 by full title (Publication Manual of the American Psychological Association, 7th ed.). Use <em>dissertation</em> or <em>thesis</em> to match your document type.</p>
	<p><strong>Typical length</strong></p>
	<p>One sentence.</p>
	<p><strong>Guidance notes</strong></p>
	<p>Place per your school’s instructions (often after title page or abstract). This control inserts the sentence at the end of the document body; you may cut and paste it elsewhere.</p>
	<p><strong>What to avoid</strong></p>
	<ul>
		<li>Wrong edition (e.g., 6th ed.) or vague “APA style” without naming the manual.</li>
		<li>Duplicating the statement if your committee already supplies fixed wording—use their text instead.</li>
	</ul>
	<p><strong>Quick reminder</strong></p>
	<p>Toggle “Include APA Style Compliance Statement” in Document settings; preview shows the exact sentence.</p>
	<p><strong>Example</strong></p>
	<p style="font-style:italic;">This dissertation follows the style guidelines of the Publication Manual of the American Psychological Association (7th ed.).</p>
</div>`;
}
